<div class="input-wrapper">
  @if (showTitle) {
    <div class="d-flex align-items-center form-title mt-2" [ngClass]="isLight ? 'light' : 'dark'">
      <div class="d-flex align-items-center p-2">
        <img class="section-image" src="../../assets/icon/article.svg" alt="document" />
      </div>
      <div class="form-title-text-container">
        <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
          {{ titleKey | translate }}
        </p>
      </div>
    </div>
  }

  <div class="d-flex align-items-center gap-2">
    <label [for]="inputId" class="custom-file-upload" [ngClass]="isLight ? 'light' : 'dark'">
      <app-icam-icon iconName="attachment" />
      {{ labelKey | translate }}
    </label>

    @if (typesPopoverLabel || accept) {
      <div
        class="popover-trigger"
        [ngbPopover]="typesPopoverLabel ? typesPopoverLabel : ('acceptedFiles' | translate) + ' ' + accept"
        triggers="mouseenter:mouseleave"
        [popoverClass]="'icam-popover ' + (isLight ? 'light' : 'dark')"
      >
        <app-icam-icon [iconName]="'info-circle'" />
      </div>
    }

    @if (infoPopover || infoPopover === '') {
      <div
        class="popover-trigger"
        [ngbPopover]="infoPopover"
        triggers="mouseenter:mouseleave"
        [popoverClass]="'icam-popover ' + (isLight ? 'light' : 'dark')"
      >
        <app-icam-icon [iconName]="'info-circle'" />
      </div>
    }
  </div>

  <input
    [id]="inputId"
    type="file"
    style="display: none"
    (change)="onFileSelected($event)"
    [attr.accept]="accept"
    [attr.multiple]="multiple ? true : null"
  />

  @if (displayName && !hideLabel) {
    <p class="file-label" [ngClass]="isLight ? 'light' : 'dark'">
      {{ displayName }}
      <small
        class="text-decoration-underline"
        role="button"
        (click)="removeFile()"
        (keydown.enter)="removeFile()"
        tabindex="0"
      >
        ({{ 'COMMON.REMOVE' | translate }})
      </small>
    </p>
  }
</div>
